import Grid from "@mui/material/Grid";
import OkwindIcon from "../../OkwindIcon";
import {Box, Checkbox, Typography, Link} from "@mui/material";
import {useState} from "react";
import apiV2 from "../../service/api/ApiV2";
import {LoadingButton} from "@mui/lab";
import {Trans, useTranslation} from "react-i18next";

function PrivacyApprovalView() {
  const {t} = useTranslation();
  const [isApproved, setIsApproved] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleOk = () => {
    setLoading(true);
    apiV2.approvePrivacyPolicy().finally(() => {
      setLoading(false);
      // Reload the page
      window.location.reload();
    });
  };
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <Grid
        container
        spacing={2}
        sx={{
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <Grid
          container
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center",
            justifyContent: "center",
          }}>
          <Grid
            sx={{
              marginBottom: "-20px",
            }}>
            <OkwindIcon />
          </Grid>
          <Grid>
            <Box
              sx={{
                borderLeft: "4px solid black",
                height: "40px",
                marginX: 1,
              }}
            />
          </Grid>
          <Grid>
            <Typography gutterBottom variant="h5" component="div" style={{fontWeight: "bold"}}>
              {t("privacy.title")}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          spacing={1}
          size={{
            xs: 10,
            sm: 6,
            lg: 3,
          }}
          sx={{
            alignItems: "center",
            justifyContent: "center",
            marginTop: 6,
          }}>
          <Grid
            container
            spacing={1}
            sx={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: 1,
            }}>
            <Grid style={{textAlign: "center"}}>
              <Typography style={{fontWeight: "bold"}} variant="subtitle1" color="primary">
                {t("privacy.updated")}
              </Typography>
            </Grid>
            <Grid
              size={{
                xs: 10,
                sm: 6,
                lg: 4,
              }}>
              <p>{t("privacy.gdpr")}</p>
            </Grid>
            <Grid
              container
              direction="row"
              spacing={1}
              sx={{
                alignItems: "center",
                justifyContent: "center",
                marginTop: 1,
              }}>
              <Grid>
                <Checkbox
                  checked={isApproved}
                  onChange={(event) => {
                    setIsApproved(event.target.checked);
                  }}
                />
              </Grid>
              <Grid size="grow">
                <p>
                  <Trans
                    t={t}
                    i18nKey="privacy.consent"
                    components={{
                      policyLink: <Link color="inherit" href="/privacy_okwind.html" target="_blank" rel="noopener" />,
                    }}
                  />
                </p>
              </Grid>
            </Grid>
            <Grid
              sx={{
                marginTop: 2,
              }}>
              <LoadingButton
                variant="contained"
                onClick={handleOk}
                style={{color: "white"}}
                disabled={!isApproved}
                loading={loading}>
                {t("privacy.validate")}
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PrivacyApprovalView;
